// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cw-j";
export var fulfillmentFormRail = "_cw-i";
export var headerTitleRow = "_cw-l";
export var orderDetailsWrapper = "_cw-g";
export var orderLinkTrigger = "_cw-2";
export var paymentInformationGrid = "_cw-q";
export var paymentSummaryColumn = "_cw-r";
export var phoneShipmentPickerButton = "_cw-e";
export var phoneShipmentPickerButtonContent = "_cw-f";
export var phoneShipmentPickerButtonWrapper = "_cw-d";
export var phoneShipmentPickerTrigger = "_cw-c";
export var shipmentContainer = "_cw-k";
export var shipmentDetailsMainPane = "_cw-h";
export var shipmentNavigationCard = "_cw-a";
export var shipmentNavigationEdgeTrigger = "_cw-6";
export var shipmentNavigationRail = "_cw-3";
export var shipmentNavigationRailEnter = "_cw-5";
export var shipmentNavigationRailHeader = "_cw-9";
export var shipmentNavigationRailOverlay = "_cw-4";
export var shipmentNavigationScrim = "_cw-7";
export var shipmentSummaryFact = "_cw-n";
export var shipmentSummaryGrid = "_cw-m";
export var shipmentSummaryMetadataRow = "_cw-o";
export var shipmentSummaryTags = "_cw-p";
export var shipmentWorkspace = "_cw-0";
export var shipmentWorkspaceBodyTablet = "_cw-8";
export var shipmentWorkspaceContent = "_cw-b";
export var shipmentWorkspaceHeader = "_cw-1";